<mat-form-field (click)="open($event)" fxFlex="100">
	<input
		#dateInput
		(datesUpdated)="dateSelected.emit($event)"
		*ngIf="!previousDateSelector"
		[(ngModel)]="selected"
		[alwaysShowCalendars]="true"
		[dateLimit]="dateLimit"
		[locale]="locale"
		[minDate]="minDate"
		[opens]="opens"
		[placeholder]="placeholder"
		[ranges]="ranges"
		[showCustomRangeLabel]="true"
		[showRangeLabelOnInput]="true"
		class="form-control"
		matInput
		ngxDaterangepickerMd
		type="text"
	/>
	<input
		(datesUpdated)="dateSelected.emit($event)"
		*ngIf="previousDateSelector"
		[(ngModel)]="selected"
		[alwaysShowCalendars]="true"
		[dateLimit]="dateLimit"
		[locale]="locale"
		[maxDate]="maxDate"
		[opens]="opens"
		[placeholder]="placeholder"
		[ranges]="previousRanges"
		[showCustomRangeLabel]="true"
		[showRangeLabelOnInput]="true"
		class="form-control"
		matInput
		ngxDaterangepickerMd
		type="text"
	/>
	<mat-icon (click)="open($event)" matSuffix style="cursor: pointer" tabIndex="-1">
		date_range
	</mat-icon>
</mat-form-field>
